import { Box } from '@mui/material';
import { useState, useRef } from 'react';
import { Header } from '@/types/generated';
import LocationDetails from './LocationDetails/LocationDetails';
import { getLocationNavigationBarStyles, searchWrapStyles } from './LocationNavBar.styles';
import LocationNavMenu from './LocationNavMenu/LocationNavMenu';
import LocationSearch from './LocationSearch/LocationSearch';
import SchedulingButton from '../SchedulingButton/SchedulingButton';
import { useFacilityContext } from '@shared-components/context';
import { Maybe } from '@shared-components/types';
interface ILocationNavBar {
  schedulingButtonText?: Maybe<string>;
  schedulingButtonTextMobile?: Maybe<string>;
  locationBarFindOfficeUrl?: Header['locationBarFindOfficeUrl'];
  schedulingButtonUrl?: Header['schedulingButtonUrl'];
  isMobile?: boolean;
  searchFieldTitle?: Maybe<string>;
}
export default function LocationNavBar({
  schedulingButtonText,
  locationBarFindOfficeUrl,
  schedulingButtonTextMobile,
  isMobile,
  searchFieldTitle,
  schedulingButtonUrl
}: Readonly<ILocationNavBar>) {
  const {
    officeInfo
  } = useFacilityContext();
  const [searchOpened, setSearchOpened] = useState(false);
  const locationNavBarRef = useRef<HTMLDivElement>(null);
  const schedulingButtonUrlFinal = officeInfo?.scheduling?.schedulingUrl || schedulingButtonUrl;
  return <Box data-testid="location_navigation_bar" sx={getLocationNavigationBarStyles(isMobile)} ref={locationNavBarRef} data-sentry-element="Box" data-sentry-component="LocationNavBar" data-sentry-source-file="LocationNavBar.tsx">
			<Box sx={searchWrapStyles} data-sentry-element="Box" data-sentry-source-file="LocationNavBar.tsx">
				{officeInfo && !searchOpened ? <LocationDetails setSearchOpened={setSearchOpened} isMobile={isMobile} locationNavBarRef={locationNavBarRef} /> : <LocationSearch locationBarFindOfficeUrl={locationBarFindOfficeUrl} isMobile={isMobile} locationNavBarRef={locationNavBarRef} searchOpened={searchOpened} searchFieldTitle={searchFieldTitle} onLocationSelected={() => setSearchOpened(false)} />}
				{!isMobile && <LocationNavMenu />}
			</Box>
			<SchedulingButton schedulingButtonUrl={schedulingButtonUrlFinal} schedulingButtonText={schedulingButtonText} schedulingButtonTextMobile={schedulingButtonTextMobile} isMobile={isMobile} data-sentry-element="SchedulingButton" data-sentry-source-file="LocationNavBar.tsx" />
		</Box>;
}